import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IntlProvider } from 'react-intl';

const LanguageProvider = ({ messages, children }) => {
  const { locale } = useSelector((state) => state.lang);
  const dispatch = useDispatch();
  useEffect(()=>{
    const newLocale = navigator.language.substring(0,2) || 'en';
    dispatch({ type: 'change_locale', payload: {locale: newLocale} })
  }, [dispatch])

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale])

  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={messages[locale]}
    >
      {React.Children.only(children)}
    </IntlProvider>
  )
}

export default LanguageProvider;
